import React, { useEffect, useState } from 'react';
import { FaEdit, FaExternalLinkAlt, FaPlus, FaTrash } from 'react-icons/fa';
import './FacultyList.css';
import AddFaculty from "./AddFaculty.jsx";
import EditFacultyModal from "./EditFacultyModal.jsx"; 
import axios from 'axios';
import { Base_Url } from '../config';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import dummy from "../Assests/dummy.jpg";

// Email Obfuscator Component
const EmailObfuscator = ({ email }) => {
  const [isRevealed, setIsRevealed] = useState(false);
  
  const handleReveal = () => {
    setIsRevealed(true);
  };

  return (
    <span 
      onClick={!isRevealed ? handleReveal : undefined}
      style={{ 
        cursor: !isRevealed ? 'pointer' : 'default',
        // filter: !isRevealed ? 'blur(4px)' : 'none',
        transition: 'filter 0.3s ease',
        userSelect: 'text'
      }}
      title={!isRevealed ? " Click to reveal email" : ""}
    >
      {!isRevealed ? " Click to reveal email" :  email}
    </span>
  );
};

// const HeadOfDepartment = ({
//   id,
//   name,
//   title,
//   email,
//   office,
//   phone,
//   designation,
//   summary,
//   image,
//   website,
//   deleteFaculty,
//   openEditModal,
//   userfromwebmaster,
//   statecsc,
//   facultstaff,
//   userid
// }) => (
//   <div className="hod-container">
//     <div className="hod-card">
//       <div className="hod-header">
//         {(userfromwebmaster.userExists || 
//           statecsc.userState === 0 || 
//           (facultstaff?.facultyprofileExists && 
//             facultstaff.facultyprofileData.user_id === userid)) && (
//           <div className="hod-actions">
//             <FaTrash 
//               className="hod-action-icon text-danger" 
//               onClick={() => deleteFaculty(id)} 
//             />
//             <FaEdit 
//               className="hod-action-icon text-success" 
//               onClick={() => openEditModal({
//                 id,
//                 name,
//                 title,
//                 email,
//                 phone,
//                 summary,
//                 image,
//                 website,
//                 office,
//                 designation,
//                 userid: userfromwebmaster.userExists 
//                   ? userfromwebmaster.userData?.userid 
//                   : facultstaff.facultyprofileData.user_id,
//                 show_hod: 1
//               })} 
//             />
//           </div>
//         )}
//       </div>
      
//       <div className="hod-profile">
//         <div className="hod-image-container">
//           <img 
//             className="hod-image" 
//             src={image && image !== "" ? `${Base_Url}/${image}` : dummy} 
//             alt={`${name} - Head of Department`} 
//           />
//         </div>
        
//         <div className="hod-details">
//           <h2 className="hod-name">{name}</h2>
//           <p className="hod-designation">(Head CSC)</p>
//           <p className="hod-title">{title}</p>
          
//           <div className="hod-info-grid">
//             <div className="hod-info-row">
//               <span className="hod-info-label">Email:</span>
//               <span className="hod-info-value ">
//                 <EmailObfuscator email={email} />
//               </span>
//             </div>
            
//             <div className="hod-info-row">
//               <span className="hod-info-label">Phone:</span>
//               <span className="hod-info-value">{phone}</span>
//             </div>
            
//             <div className="hod-info-row">
//               <span className="hod-info-label">Work Summary:</span>
//               <span className="hod-info-value">{summary}</span>
//             </div>
//           </div>
          
//           <div className="hod-buttons">
//             {website && website.trim() !== "" && (
//               <a 
//                 className="hod-button" 
//                 href={website} 
//                 target="_blank" 
//                 rel="noopener noreferrer"
//               >
//                 Webpage <FaExternalLinkAlt />
//               </a>
//             )}
//             <Link 
//               to={`/people/${id}`} 
//               className="hod-button" 
//               target="_blank" 
//               rel="noopener noreferrer"
//             >
//               Profile <FaExternalLinkAlt />
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// );

// Refactored HeadOfDepartment Component

const HeadOfDepartment = (props) => {
  const {
    id, name, title, email, office, phone, designation, summary, image, website,
    deleteFaculty, openEditModal, userfromwebmaster, statecsc, facultstaff, userid
  } = props;

  // Check if user has edit permissions
  const canEdit = userfromwebmaster.userExists || 
    statecsc.userState === 0 || 
    (facultstaff?.facultyprofileExists && facultstaff.facultyprofileData.user_id === userid);

  // Handle edit modal opening
  const handleEditClick = () => {
    openEditModal({
      id, name, title, email, phone, summary, image, website, office, designation,
      userid: userfromwebmaster.userExists 
        ? userfromwebmaster.userData?.userid 
        : facultstaff.facultyprofileData.user_id,
      show_hod: 1
    });
  };

  // Profile image source
  const imageSource = image && image !== "" ? `${Base_Url}/${image}` : dummy;

  return (
    <div className="hod-container">
      <div className="hod-card">
        
        {/* Action Buttons Header */}
        <div className="hod-header">
          {canEdit && (
            <div className="hod-actions">
              <FaTrash 
                className="hod-action-icon text-danger" 
                onClick={() => deleteFaculty(id)} 
              />
              <FaEdit 
                className="hod-action-icon text-success" 
                onClick={handleEditClick} 
              />
            </div>
          )}
        </div>

        {/* Main Profile Section */}
        <div className="hod-profile">
          
          {/* Profile Image */}
          <div className="hod-image-container">
            <img 
              className="hod-image" 
              src={imageSource} 
              alt={`${name} - Head of Department`} 
            />
          </div>

          {/* Profile Details */}
          <div className="hod-details">
            <h2 className="hod-name">{name}</h2>
            <p className="hod-designation">(Head CSC)</p>
            <p className="hod-title">{title}</p>

            {/* Contact Information Grid */}
            <div className="hod-info-grid">
              <div className="hod-info-row">
                <span className="hod-info-label">Email:</span>
                <span className="hod-info-value">
                  <EmailObfuscator email={email} />
                </span>
              </div>
              
              <div className="hod-info-row">
                <span className="hod-info-label">Phone:</span>
                <span className="hod-info-value">{phone}</span>
              </div>
              
              <div className="hod-info-row">
                <span className="hod-info-label">Work Summary:</span>
                <span className="hod-info-value">{summary}</span>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="hod-buttons">
              {website && website.trim() !== "" && (
                <a 
                  className="hod-button" 
                  href={website} 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Webpage <FaExternalLinkAlt />
                </a>
              )}
              <Link 
                to={`/people/${id}`} 
                className="hod-button" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Profile <FaExternalLinkAlt />
              </Link>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};



const FacultyMember = ({ statecsc, staffuser, id, name, title, email, phone, designation, summary, office, image, website, deleteFaculty, openEditModal, facultstaff, userid, userfromwebmaster }) => (
  <div className="faculty-card">
    <div className="faculty-card-header">
      {(userfromwebmaster.userExists || statecsc.userState === 0 || 
        (facultstaff?.facultyprofileExists && facultstaff.facultyprofileData.user_id === userid)) && (
        <>
          <FaTrash 
            className="faculty-trash-icon text-danger" 
            onClick={() => deleteFaculty(id)} 
          />
          <FaEdit
            className="ms-2 faculty-edit-icon text-success"
            onClick={() => openEditModal({ 
              id,
              name,
              title,
              email,
              phone,
              summary,
              image,
              website,
              office,
              userid: userfromwebmaster.userExists ? 
                userfromwebmaster.userData?.userid : facultstaff.facultyprofileData.user_id,
              designation,
              show_hod: 0
            })}
          />
        </>
      )}
    </div>
    <img 
      className="faculty-image" 
      src={(image && image !== "") ? `${Base_Url}/${image}` : dummy} 
      alt={name} 
    />
    <div className="faculty-info">
      <h3 className="faculty-name">{name}</h3>
      <p className="faculty-title">{title}</p>
      <p className="faculty-title">{designation}</p>
      <p className="faculty-email">
        <span className="faculty-phone-span " style={{ fontWeight: "600", color: "#555" }}>Email:</span> 
        <EmailObfuscator email={email} />
      </p>
      <p className="faculty-phone">
        <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Phone:</span> {phone}
      </p>
      <p className="faculty-research">
        <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Work Summary:</span> {summary}
      </p>
      <div className="faculty-buttons">
        {website && website.trim() !== "" && (
          <a className="faculty-button" href={website} target="_blank" rel="noopener noreferrer">
            Webpage <FaExternalLinkAlt />
          </a>
        )}
        <Link to={`/people/${id}`} className="faculty-button" target="_blank" rel="noopener noreferrer">
          Profile <FaExternalLinkAlt />
        </Link>
      </div>
    </div>
  </div>
);

const Faculty = () => {
  const [modal, setModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editObj, setEditObj] = useState(null);
  const [head, setHead] = useState([]);
  const [faculty, setAllFaculty] = useState([]);

  const userfromwebmaster = useSelector((state) => state.user);
  const facultstaff = useSelector((state) => state.facultyuser);
  const statecsc = useSelector((state) => state.statecsc);
  const staffuser = useSelector((state) => state.staffuser);

  const fetchFaculty = async () => {
    try {
      const response = await axios.get(`${Base_Url}/profiles`);
      const data = response.data.filter(person => 
        person.show_in_display === 1 && person.isretired === 0
      );

      const headPerson = data.filter(person => person.show_hod === 1);
      const facultyMembers = data.filter(person => 
        !person.show_hod && ['Sr. System Manager (SG)', 'System Manager', 'System Architect'].includes(person.designation)
      );

      setHead(headPerson);
      setAllFaculty(facultyMembers);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const deleteFaculty = async (id) => {
    if (window.confirm("Are you sure you want to delete this member?")) {
      try {
        await axios.delete(`${Base_Url}/profile/${id}`);
        fetchFaculty();
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  const openEditModal = (faculty) => {
    setEditObj(faculty);
    setEditModal(true);
  };

  useEffect(() => {
    fetchFaculty();
  }, []);

  return (
    <>
      <AddFaculty 
        modal={modal} 
        closeModal={() => setModal(false)} 
        fetchFaculty={fetchFaculty} 
      />
      <EditFacultyModal
        modal={editModal}
        closeModal={() => {
          setEditModal(false);
          setEditObj(null);
        }}
        editObj={editObj}
        fetchFaculty={fetchFaculty}
      />
      
      <div className="faculty-container ">
        <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0 text-center">
          Head <span className="highlight-title text-center mt-4">CSC</span>
        </h2>
        
        {head.map((elem) => (
          <HeadOfDepartment
            key={elem.id}
            {...elem}
            summary={elem.summary}
            image={elem.image_path}
            website={elem.weblink}
            deleteFaculty={deleteFaculty}
            openEditModal={openEditModal}
            facultstaff={facultstaff}
            userfromwebmaster={userfromwebmaster}
            statecsc={statecsc}
            staffuser={staffuser}
          />
        ))}

        <div className='d-flex justify-content-center align-items-center'>
          <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0 ">
            Academic <span className="highlight-title">Members</span>
          </h2>
          {userfromwebmaster.userExists && 
            <FaPlus onClick={() => setModal(true)} className='ms-2 text-primary mt-2' />
          }
        </div>

        <div className="row">
          {faculty.sort((a, b) => a?.name?.localeCompare(b.name)).map((elem) => (
            <div key={elem.id} className="col-md-6 mb-4">
              <FacultyMember
                {...elem}
                summary={elem.summary}
                image={elem.image_path}
                website={elem.weblink}
                deleteFaculty={deleteFaculty}
                openEditModal={openEditModal}
                facultstaff={facultstaff}
                userfromwebmaster={userfromwebmaster}
                statecsc={statecsc}
                staffuser={staffuser}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Faculty;

// import React, { useEffect, useState } from 'react';
// import { FaEdit, FaExternalLinkAlt, FaPlus, FaTrash } from 'react-icons/fa';
// import './FacultyList.css';
// import AddFaculty from "./AddFaculty.jsx";
// import EditFacultyModal from "./EditFacultyModal.jsx"; 
// import axios from 'axios';
// import { Base_Url } from '../config';
// import { Link } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import dummy from "../Assests/dummy.jpg";




// const HeadOfDepartment = ({
//   id,
//   name,
//   title,
//   email,
//   office,
//   phone,
//   designation,
//   summary,
//   image,
//   website,
//   deleteFaculty,
//   openEditModal,
//   userfromwebmaster,
//   statecsc,
//   facultstaff,
//   userid
// }) => (
//   <div className="hod-container">
//     <div className="hod-card">
//       <div className="hod-header">
//         {(userfromwebmaster.userExists || 
//           statecsc.userState === 0 || 
//           (facultstaff?.facultyprofileExists && 
//             facultstaff.facultyprofileData.user_id === userid)) && (
//           <div className="hod-actions">
//             <FaTrash 
//               className="hod-action-icon text-danger" 
//               onClick={() => deleteFaculty(id)} 
//             />
//             <FaEdit 
//               className="hod-action-icon text-success" 
//               onClick={() => openEditModal({
//                 id,
//                 name,
//                 title,
//                 email,
//                 phone,
//                 summary,
//                 image,
//                 website,
//                 office,
//                 designation,
//                 userid: userfromwebmaster.userExists 
//                   ? userfromwebmaster.userData?.userid 
//                   : facultstaff.facultyprofileData.user_id,
//                 show_hod: 1
//               })} 
//             />
//           </div>
//         )}
//       </div>
      
//       <div className="hod-profile">
//         <div className="hod-image-container">
//           <img 
//             className="hod-image" 
//             src={image && image !== "" ? `${Base_Url}/${image}` : dummy} 
//             alt={`${name} - Head of Department`} 
//           />
//         </div>
        
//         <div className="hod-details">
//           <h2 className="hod-name">{name}</h2>
//           <p className="hod-designation">(Head CSC)</p>
//           <p className="hod-title">{title}</p>
          
//           <div className="hod-info-grid">
//             <div className="hod-info-row">
//               <span className="hod-info-label">Email:</span>
//               <span className="hod-info-value">{email}</span>
//             </div>
            
//             <div className="hod-info-row">
//               <span className="hod-info-label">Phone:</span>
//               <span className="hod-info-value">{phone}</span>
//             </div>
            
//             <div className="hod-info-row">
//               <span className="hod-info-label">Work Summary:</span>
//               <span className="hod-info-value">{summary}</span>
//             </div>
//           </div>
          
//           <div className="hod-buttons">
//             {website && website.trim() !== "" && (
//               <a 
//                 className="hod-button" 
//                 href={website} 
//                 target="_blank" 
//                 rel="noopener noreferrer"
//               >
//                 Webpage <FaExternalLinkAlt />
//               </a>
//             )}
//             <Link 
//               to={`/people/${id}`} 
//               className="hod-button" 
//               target="_blank" 
//               rel="noopener noreferrer"
//             >
//               Profile <FaExternalLinkAlt />
//             </Link>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// );


// const FacultyMember = ({ statecsc, staffuser, id, name, title, email, phone, designation, summary, office, image, website, deleteFaculty, openEditModal, facultstaff, userid, userfromwebmaster }) => (
//   <div className="faculty-card">
//     <div className="faculty-card-header">
//       {(userfromwebmaster.userExists || statecsc.userState === 0 || 
//         (facultstaff?.facultyprofileExists && facultstaff.facultyprofileData.user_id === userid)) && (
//         <>
//           <FaTrash 
//             className="faculty-trash-icon text-danger" 
//             onClick={() => deleteFaculty(id)} 
//           />
//           <FaEdit
//             className="ms-2 faculty-edit-icon text-success"
//             onClick={() => openEditModal({ 
//               id,
//               name,
//               title,
//               email,
//               phone,
//               summary,
//               image,
//               website,
//               office,
//               userid: userfromwebmaster.userExists ? 
//                 userfromwebmaster.userData?.userid : facultstaff.facultyprofileData.user_id,
//               designation,
//               show_hod: 0
//             })}
//           />
//         </>
//       )}
//     </div>
//     <img 
//       className="faculty-image" 
//       src={(image && image !== "") ? `${Base_Url}/${image}` : dummy} 
//       alt={name} 
//     />
//     <div className="faculty-info">
//       <h3 className="faculty-name">{name}</h3>
//       <p className="faculty-title">{title}</p>
//       <p className="faculty-title">{designation}</p>
//       <p className="faculty-email">
//         <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Email:</span> {email}
//       </p>
//       <p className="faculty-phone">
//         <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Phone:</span> {phone}
//       </p>
//       <p className="faculty-research">
//         <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Work Summary:</span> {summary}
//       </p>
//       <div className="faculty-buttons">
//         {website && website.trim() !== "" && (
//           <a className="faculty-button" href={website} target="_blank" rel="noopener noreferrer">
//             Webpage <FaExternalLinkAlt />
//           </a>
//         )}
//         <Link to={`/people/${id}`} className="faculty-button" target="_blank" rel="noopener noreferrer">
//           Profile <FaExternalLinkAlt />
//         </Link>
//       </div>
//     </div>
//   </div>
// );

// const Faculty = () => {
//   const [modal, setModal] = useState(false);
//   const [editModal, setEditModal] = useState(false);
//   const [editObj, setEditObj] = useState(null);
//   const [head, setHead] = useState([]);
//   const [faculty, setAllFaculty] = useState([]);

//   const userfromwebmaster = useSelector((state) => state.user);
//   const facultstaff = useSelector((state) => state.facultyuser);
//   const statecsc = useSelector((state) => state.statecsc);
//   const staffuser = useSelector((state) => state.staffuser);

//   const fetchFaculty = async () => {
//     try {
//       const response = await axios.get(`${Base_Url}/profiles`);
//       const data = response.data.filter(person => 
//         person.show_in_display === 1 && person.isretired === 0
//       );

//       const headPerson = data.filter(person => person.show_hod === 1);
//       const facultyMembers = data.filter(person => 
//         !person.show_hod && ['Sr. System Manager (SG)', 'System Manager', 'System Architect'].includes(person.designation)
//       );

//       setHead(headPerson);
//       setAllFaculty(facultyMembers);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//     }
//   };

//   const deleteFaculty = async (id) => {
//     if (window.confirm("Are you sure you want to delete this member?")) {
//       try {
//         await axios.delete(`${Base_Url}/profile/${id}`);
//         fetchFaculty();
//       } catch (error) {
//         console.error(error.message);
//       }
//     }
//   };

//   const openEditModal = (faculty) => {
//     setEditObj(faculty);
//     setEditModal(true);
//   };

//   useEffect(() => {
//     fetchFaculty();
//   }, []);

//   return (
//     <>
//       <AddFaculty 
//         modal={modal} 
//         closeModal={() => setModal(false)} 
//         fetchFaculty={fetchFaculty} 
//       />
//       <EditFacultyModal
//         modal={editModal}
//         closeModal={() => {
//           setEditModal(false);
//           setEditObj(null);
//         }}
//         editObj={editObj}
//         fetchFaculty={fetchFaculty}
//       />
      
//       <div className="faculty-container mt-5">
//         <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0 text-center">
//           Head <span className="highlight-title text-center mt-4">CSC</span>
//           {/* {userfromwebmaster.userExists && 
//             <FaPlus onClick={() => setModal(true)} className='ms-2 fs-5 text-primary mt-2' />
//           } */}
//         </h2>
        
//         {head.map((elem) => (
//           <HeadOfDepartment
//             key={elem.id}
//             {...elem}
//             summary={elem.summary}
//             image={elem.image_path}
//             website={elem.weblink}
//             deleteFaculty={deleteFaculty}
//             openEditModal={openEditModal}
//             facultstaff={facultstaff}
//             userfromwebmaster={userfromwebmaster}
//             statecsc={statecsc}
//             staffuser={staffuser}
//           />
//         ))}

//         <div className='d-flex justify-content-center align-items-center'>
//           <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0">
//             Faculty <span className="highlight-title">Members</span>
//           </h2>
//           {userfromwebmaster.userExists && 
//             <FaPlus onClick={() => setModal(true)} className='ms-2 text-primary mt-2' />
//           }
//         </div>

//         <div className="row">
//           {faculty.sort((a, b) => a?.name?.localeCompare(b.name)).map((elem) => (
//             <div key={elem.id} className="col-md-6 mb-4">
//               <FacultyMember
//                 {...elem}
//                 summary={elem.summary}
//                 image={elem.image_path}
//                 website={elem.weblink}
//                 deleteFaculty={deleteFaculty}
//                 openEditModal={openEditModal}
//                 facultstaff={facultstaff}
//                 userfromwebmaster={userfromwebmaster}
//                 statecsc={statecsc}
//                 staffuser={staffuser}
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Faculty;




// working code of hod

// const HeadOfDepartment = ({
//   id,
//   name,
//   title,
//   email,
//   office,
//   phone,
//   designation,
//   summary,
//   image,
//   website,
//   deleteFaculty,
//   openEditModal,
//   userfromwebmaster,
//   statecsc,
//   facultstaff,
//   userid
// }) => (
//   <div className="hod-container col-12">
//     <div className="hod-card col-4">
//       <img 
//         className="hod-image mt-4" 
//         src={image == "" ? `${Base_Url}/${image}` : dummy} 
//         alt="HOD" 
//       />
//       <div className="hod-info">
//         <div className="faculty-card">
//           <div className="faculty-card-header">
//             {(userfromwebmaster.userExists || 
//               statecsc.userState === 0 || 
//               (facultstaff?.facultyprofileExists && 
//                 facultstaff.facultyprofileData.user_id === userid)) && (
//               <div className="d-flex justify-content-end">
//                 <FaTrash 
//                   className="faculty-trash-icon text-danger" 
//                   onClick={() => deleteFaculty(id)} 
//                 />
//                 <FaEdit 
//                   className="ms-2 faculty-edit-icon text-success" 
//                   onClick={() => openEditModal({
//                     id,
//                     name,
//                     title,
//                     email,
//                     phone,
//                     summary,
//                     image,
//                     website,
//                     office,
//                     designation,
//                     userid: userfromwebmaster.userExists 
//                       ? userfromwebmaster.userData?.userid 
//                       : facultstaff.facultyprofileData.user_id,
//                     show_hod: 1
//                   })} 
//                 />
//               </div>
//             )}
//           </div>
          
//           <div className="faculty-info">
//             <h3 className="faculty-name text-center mb-1 text-center d-flex justify-content-center">{name}</h3>
//             <p className="faculty-designation text-center mb-3 faculty-name fs-6 text-center">(Head CSC)</p>
//             <p className="faculty-title text-center mb-4">{title}</p>

//             <div className="info-grid">
//               <div className="info-row d-flex mb-2 " style={{marginLeft:"5rem"}}>
//                 <div className="info-label" style={{ width: "120px", fontWeight: "600", color: "#555" }}>
//                   Email:
//                 </div>
//                 <div className="info-value" style={{  color: "#555" }}>
//                   {email}
//                 </div>
//               </div>

//               <div className="info-row d-flex mb-2  " style={{marginLeft:"5rem"}}>
//                 <div className="info-label" style={{ width: "120px", fontWeight: "600", color: "#555" }}>
//                   Phone:
//                 </div>
//                 <div className="info-value" style={{  color: "#555" }}>
//                   {phone}
//                 </div>
//               </div>

//               <div className="info-row d-flex mb-2" style={{marginLeft:"5rem"}}>
//                 <div className="info-label" style={{ width: "120px", fontWeight: "600", color: "#555" }}>
//                   Work Summary:
//                 </div>
//                 <div className="info-value ms-2" style={{minWidth:"400px",  color: "#555" }}>
//                   {summary}
//                 </div>
//               </div>
//             </div>

//             <div className="faculty-buttons d-flex justify-content-center mt-4">
//               {website && website.trim() !== "" && (
//                 <a 
//                   className="faculty-button me-2" 
//                   href={website} 
//                   target="_blank" 
//                   rel="noopener noreferrer"
//                 >
//                   Webpage <FaExternalLinkAlt className="ms-1" />
//                 </a>
//               )}
//               <Link 
//                 to={`/people/${id}`} 
//                 className="faculty-button" 
//                 target="_blank" 
//                 rel="noopener noreferrer"
//               >
//                 Profile <FaExternalLinkAlt className="ms-1" />
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// );
// const HeadOfDepartment = ({ id, name, title, email, office, phone, designation, summary, image, website, deleteFaculty, openEditModal, userfromwebmaster, statecsc, facultstaff, userid }) => (
//   <div className="hod-container col-12">
//     <div className="hod-card col-3">
//       <img className="hod-image mt-4" src={image !== "" ? `${Base_Url}/${image}` : dummy} alt="HOD" />
//       <div className="hod-info">
//         <div className="faculty-card">
//           <div className="faculty-card-header">
//             {(userfromwebmaster.userExists || statecsc.userState === 0 || 
//               (facultstaff?.facultyprofileExists && facultstaff.facultyprofileData.user_id === userid)) && (
//               <>
//                 <FaTrash 
//                   className="faculty-trash-icon text-danger" 
//                   onClick={() => deleteFaculty(id)} 
//                 />
//                 <FaEdit
//                   className="ms-2 faculty-edit-icon text-success"
//                   onClick={() => openEditModal({ 
//                     id,
//                     name,
//                     title,
//                     email,
//                     phone,
//                     summary,
//                     image,
//                     website,
//                     office,
//                     designation,
//                     userid: userfromwebmaster.userExists ? 
//                       userfromwebmaster.userData?.userid : facultstaff.facultyprofileData.user_id,
//                     show_hod: 1
//                   })}
//                 />
//               </>
//             )}
//           </div>

//           <div className="faculty-info ">
//             <h3 className="faculty-name text-center d-flex justify-content-center">{name}</h3>
//             <p className="faculty-name fs-6 text-center">(Head CSC)</p>
//             <p className="faculty-title d-flex justify-content-center">{title}</p>
//             <p className="faculty-email d-flex justify-content-center">
//               <span className="faculty-phone-span d-flex justify-content-center" style={{ fontWeight: "600", color: "#555" }}>Email:</span> {email}
//             </p>
//             <p className="faculty-phone d-flex justify-content-center">
//               <span className="faculty-phone-span " style={{ fontWeight: "600", color: "#555" }}>Phone:</span> {phone}
//             </p>
//             <p className="faculty-research d-flex justify-content-center">
//               <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Work Summary:</span> {summary}
//             </p>
//             <div className="faculty-buttons d-flex justify-content-center">
//               {website && website.trim() !== "" && (
//                 <a className="faculty-button" href={website} target="_blank" rel="noopener noreferrer">
//                   Webpage <FaExternalLinkAlt />
//                 </a>
//               )}
//               <Link to={`/people/${id}`} className="faculty-button" target="_blank" rel="noopener noreferrer">
//                 Profile <FaExternalLinkAlt />
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// );
